import { Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

// Redirect back to dashboard after auth
const REDIRECT_URL = `${window.location.origin}/dashboard`;
const AUTH_URL = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(REDIRECT_URL)}`;

export default function LandingPage() {
  const handleLogin = () => {
    console.log("Redirecting to auth URL:", AUTH_URL);
    console.log("Expected redirect back to:", REDIRECT_URL);
    window.location.href = AUTH_URL;
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-amber-50">
      {/* Header */}
      <header className="container mx-auto px-4 py-6">
        <div className="flex items-center space-x-3">
          <Heart className="w-8 h-8 text-emerald-700" />
          <span className="text-2xl font-bold text-gray-800">Soul Aid</span>
        </div>
      </header>

      {/* Hero Section */}
      <section className="container mx-auto px-4 pt-20 pb-32">
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-gray-900 mb-6 leading-tight">
            Your Personal
            <span className="block text-emerald-700">Evangelism Companion</span>
          </h1>
          
          <p className="text-lg sm:text-xl text-gray-600 mb-8 max-w-2xl mx-auto leading-relaxed">
            Track your ministry activities, manage Bible studies, record personal visits, and nurture prospects—all in one organized, searchable platform.
          </p>

          <Button 
            data-testid="login-button"
            onClick={handleLogin}
            size="lg"
            className="bg-emerald-700 hover:bg-emerald-800 text-white px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
          >
            <Heart className="w-5 h-5 mr-2" />
            Sign in with Google
          </Button>
        </div>
      </section>

      {/* Features Grid */}
      <section className="container mx-auto px-4 py-16">
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          <FeatureCard 
            title="Task Management"
            description="Create customizable daily, weekly, and monthly to-do lists to organize your evangelism activities."
          />
          <FeatureCard 
            title="Visit Tracking"
            description="Record personal visits with notes, follow-up dates, and searchable history."
          />
          <FeatureCard 
            title="Bible Study Creator"
            description="Build custom Bible studies with NKJV Scripture search and topical organization."
          />
          <FeatureCard 
            title="Prospect Database"
            description="Maintain a searchable database of new prospects with contact details and interest levels."
          />
          <FeatureCard 
            title="Study Sessions"
            description="Track Bible study sessions conducted with dates, participants, and notes."
          />
          <FeatureCard 
            title="Export Reports"
            description="Generate comprehensive reports of your ministry activities for review and sharing."
          />
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 mt-16">
        <div className="container mx-auto px-4">
          <p className="text-center text-sm text-gray-600">
            © 2024 Abject Ministries. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

function FeatureCard({ title, description }) {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
      <h3 className="text-xl font-semibold text-gray-900 mb-3">{title}</h3>
      <p className="text-gray-600 text-sm leading-relaxed">{description}</p>
    </div>
  );
}
